import axiosInstance from "../../../configs/axios";

// User management API
export const usersAPI = {
  getPartners: async () => {
    const response = await axiosInstance.get("/user/partners");
    return response.data;
  },
  createPartner: async (data: {
    companyName: string;
    companyVatId: string;
    partnershipLevel?: string;
  }) => {
    const response = await axiosInstance.post("/user/partners", data);
    return response.data;
  },
  getAllUsers: async () => {
    const response = await axiosInstance.get("/admin/users");
    return response.data;
  },

  registerUser: async (data: {
    username: string;
    userRole: string;
    accountType: string;
    email: string;
    password: string;
    partnerCompany?: string;
    adminRole?: string;
    /** Content sections a marketer account may manage. */
    contentAccess?: string[];
  }) => {
    const response = await axiosInstance.post("/admin/register", data);
    return response.data;
  },

  updateUser: async (uuid: string, data: any) => {
    const response = await axiosInstance.put(`/admin/users/${uuid}`, data);
    return response.data;
  },

  deleteUser: async (uuid: string) => {
    const response = await axiosInstance.delete(`/admin/users/${uuid}`);
    return response.data;
  },
};
